<template>
  <div class="box">
    <div class="flex flex-wrap">
      <div class="w-full md:w-1/2 text-center md:text-left">
        <p class="font-bold">{{ name | sentenceCase }}</p>
      </div>
      <div class="w-full md:w-1/2 text-center md:text-right">
        <button
          class="btn text-xs rounded-r-none"
          :class="selectedButton === 'month' ? 'btn-green' : 'bg-theme'"
          @click="$emit('update:selectedButton', 'month')"
        >Month</button>
        <button
          class="btn text-xs rounded-none"
          :class="selectedButton === 'week' ? 'btn-green' : 'bg-theme'"
          @click="$emit('update:selectedButton', 'week')"
        >Week</button>
        <button
          class="btn text-xs rounded-l-none"
          :class="selectedButton === 'day' ? 'btn-green' : 'bg-theme'"
          @click="$emit('update:selectedButton', 'day')"
        >Today</button>
      </div>
    </div>

    <div class="flex flex-col items-center my-8">
      <p class="text-2xl font-bold leading-none" :class="priceClass">{{ $formatMoney(total) }}</p>
      <p class="text-sm">{{ date }}</p>
    </div>

    <div class="flex flex-wrap text-sm text-theme-darker light:text-theme-lighter">
      <div class="w-full md:w-1/2 text-center md:text-left">
        Total {{ name }}: {{ $numeral(grantTotal).format('0.0a') }}
      </div>
      <div class="w-full md:w-1/2 text-center md:text-right">
        <i class="fas" :class="percentageIncrease > 0 ? 'fa-caret-up text-green-500' : 'fa-caret-down text-red-500'"></i>
        {{ percentageIncrease.toFixed(2) }}%
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    name: String,
    priceClass: String,
    selectedButton: String,
    total: Number,
    grantTotal: Number,
    percentageIncrease: Number,
  },
  data() {
    return {}
  },
  computed: {
    date() {
      if (this.selectedButton === 'month') {
        return this.$moment().format('MMMM Y')
      }
      if (this.selectedButton === 'week') {
        return this.$moment().startOf('isoWeek').format('DD/MM') + ' - ' + this.$moment().endOf('isoWeek').format('DD/MM')
      }
      if (this.selectedButton === 'day') {
        return this.$moment().format('DD/MM')
      }
      return ''
    }
  }
}
</script>
